import ACCOUNT_CLIENT_API_ENDPOINTS from '@api/endpoints';
import HTTP_METHODS_ENUM from '@api/enums/HTTP_METHODS_ENUM.enum';
import configRequest from '@api/requests/configRequest';

import { showToast } from '@app/providers/ToastProvider';

import AUTH_FORM_RESET_PASSWORD_TYPES_ENUM from '../authForms/enums/AUTH_FORM_RESET_PASSWORD_TYPES_ENUM.enum';
import CODE_TYPE_ENUM from './enums/CODE_TYPE_ENUM.enum';

export interface SendResetPasswordCodeData {
	auth_form_slug?: string;
	contact?: string;
	code_type?: CODE_TYPE_ENUM;
	reset_type?: AUTH_FORM_RESET_PASSWORD_TYPES_ENUM;
}

export type SendResetPasswordCodeResponse = void;

const sendResetPasswordCode = configRequest<SendResetPasswordCodeResponse, SendResetPasswordCodeData>({
	requestPrefix: 'auth/send-reset-password-code',
	reqConfigCreator: data => ({
		url: ACCOUNT_CLIENT_API_ENDPOINTS.AUTH.RESET_PASSWORD_CODE(),
		method: HTTP_METHODS_ENUM.PUT,
		data: data as SendResetPasswordCodeData,
	}),
	onSuccess: () => showToast.success('Code has been sent.'),
});

export default sendResetPasswordCode;
